import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Address {
  id: number;
  address1: string;
  address2?: string;
  address_name?: string;
  city: string;
  state: string;
  zip: string;
  country_code?: string;
  latitude?: number;
  longitude?: number;
  timezone?: string;
  color?: string;
  key?: string;
  name?: string;
  bed_count?: number;
  bath_count?: number;
  living_area_sqft?: number;
  lot_size_sqft?: number;
  year_built?: number;
  property_type?: string;
  wifi_network?: string;
  wifi_password?: string;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class AddressesApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.api_url;

  getAddresses(): Observable<Address[]> {
    const url = `${this.baseUrl}api/v1/customer/addresses?per_page=5000&fields=country_code,color,add_state,address1,address2,address_name,city,default_address_task_list_state,id,integration,latitude,longitude,region_id,state,timezone,zip,automatic_booking_enabled,key,name,booking_cancellation_strategy,booking_end_time_no_later_than,booking_start_time_no_earlier_than,required_team_service,description,bed_count,bath_count,living_area_sqft,lot_size_sqft,year_built,property_type,wifi_network,wifi_password,id&includes=address_automatic_booking_setting`;
    return this.http.get<Address[]>(url);
  }

  getAddress(id: number): Observable<Address> {
    const url = `${this.baseUrl}api/v1/customer/addresses/${id}`;
    return this.http.get<Address>(url);
  }

  updateAddress(id: number, data: Partial<Address>): Observable<Address> {
    const url = `${this.baseUrl}api/v1/customer/addresses/${id}`;
    return this.http.put<Address>(url, data);
  }

  createAddress(data: Partial<Address>): Observable<Address> {
    const url = `${this.baseUrl}api/v1/customer/addresses`;
    return this.http.post<Address>(url, data);
  }

  deleteAddress(id: number): Observable<void> {
    const url = `${this.baseUrl}api/v1/customer/addresses/${id}`;
    return this.http.delete<void>(url);
  }
}
